import { render, staticRenderFns } from "./PwNiceAuthView.vue?vue&type=template&id=f8503f8e&scoped=true&"
import script from "./PwNiceAuthView.vue?vue&type=script&lang=js&"
export * from "./PwNiceAuthView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8503f8e",
  null
  
)

export default component.exports